<template>
	<div class="content-block">
		<div class="content-block__header">
			<div class="content-block__title">Results</div>
		</div>
		<div class="content-block__body">
			<SearchArticle
				v-for="(article, index) in filteredArticles"
				:article="article"
				:searchByFile="searchByFile"
				:key="article.link_id"
				:index="index"
			/>
		</div>
	</div>
	
</template>

<script>
import SearchArticle from "./SearchArticle";

export default {
	name: "SearchArticleList",
	components: {
		SearchArticle,
	},
	props: ['filteredArticles', 'searchByFile']
};
</script>